import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("サブコレクション移動修正結果")
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "text-lg font-bold text-gray-800 mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "bg-gray-50 border border-gray-200 rounded-md p-3 mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-600" }, " 移動が必要なサブコレクションを持つゾンビ生徒は見つかりませんでした。問題ありません。 ", -1)
const _hoisted_7 = {
  key: 1,
  class: "bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-yellow-700" }, " ゾンビ生徒は検出されましたが、対応する正規の生徒ドキュメントが存在しないため、全てスキップされました。 ", -1)
const _hoisted_9 = {
  key: 2,
  class: "bg-blue-50 border border-blue-200 rounded-md p-3 mb-4"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-blue-700" }, " ゾンビ生徒のサブコレクションは既に正規の生徒へ移動済みです。新たに復元されたドキュメントはありません。 ", -1)
const _hoisted_11 = { class: "grid grid-cols-4 gap-4 mb-4" }
const _hoisted_12 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_13 = { class: "text-2xl font-bold text-gray-700" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "処理対象生徒", -1)
const _hoisted_15 = { class: "bg-green-50 rounded-md p-3 text-center" }
const _hoisted_16 = { class: "text-2xl font-bold text-green-600" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "成功", -1)
const _hoisted_18 = { class: "bg-red-50 rounded-md p-3 text-center" }
const _hoisted_19 = { class: "text-2xl font-bold text-red-600" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "失敗", -1)
const _hoisted_21 = { class: "bg-yellow-50 rounded-md p-3 text-center" }
const _hoisted_22 = { class: "text-2xl font-bold text-yellow-600" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "スキップ", -1)
const _hoisted_24 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_25 = { class: "bg-blue-50 rounded-md p-3 text-center" }
const _hoisted_26 = { class: "text-2xl font-bold text-blue-600" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "復元したドキュメント数", -1)
const _hoisted_28 = {
  key: 4,
  class: "bg-red-50 border border-red-200 rounded-md p-3 mb-4"
}
const _hoisted_29 = { class: "text-sm text-red-700" }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_32 = { class: "bg-red-50 border border-red-200 rounded-md overflow-hidden" }
const _hoisted_33 = { class: "w-full text-sm" }
const _hoisted_34 = /*#__PURE__*/_createVNode("thead", { class: "bg-red-100" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, "生徒ID"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, " コレクション "),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, " エラー内容 ")
  ])
], -1)
const _hoisted_35 = { class: "px-3 py-2 text-gray-600 font-mono text-xs" }
const _hoisted_36 = { class: "px-3 py-2 text-gray-600" }
const _hoisted_37 = { class: "px-3 py-2 text-red-600" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "wide",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
          return (_openBlock(), _createBlock("div", {
            key: result.schoolDocId,
            class: "border border-gray-200 rounded-lg p-4"
          }, [
            _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.schoolNameMap[result.schoolDocId] || result.schoolDocId), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("span", {
                class: ["inline-block px-3 py-1 rounded-full text-sm font-medium", _ctx.getStatusBadgeClass(result.status)]
              }, _toDisplayString(_ctx.getStatusLabel(result.status)), 3)
            ]),
            (result.status === 'no_target')
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6
                ]))
              : (result.status === 'all_skipped')
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8
                  ]))
                : (_ctx.isAlreadyProcessed(result))
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10
                    ]))
                  : _createCommentVNode("", true),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, _toDisplayString(result.processedZombieCount ?? 0), 1),
                _hoisted_14
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(result.succeededZombieCount ?? 0), 1),
                _hoisted_17
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.getFailedZombieCount(result)), 1),
                _hoisted_20
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(result.skippedZombieCount ?? 0), 1),
                _hoisted_23
              ])
            ]),
            (result.status !== 'no_target' && result.status !== 'failure')
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, _toDisplayString(result.copiedDocCount ?? 0), 1),
                    _hoisted_27
                  ])
                ]))
              : _createCommentVNode("", true),
            (result.errorMessage)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("p", _hoisted_29, _toDisplayString(result.errorMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (result.errors && result.errors.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                  _createVNode("h4", _hoisted_31, " エラー詳細（" + _toDisplayString(result.errors.length) + "件） ", 1),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("table", _hoisted_33, [
                      _hoisted_34,
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(result.errors, (err, idx) => {
                          return (_openBlock(), _createBlock("tr", {
                            key: idx,
                            class: "border-t border-red-200"
                          }, [
                            _createVNode("td", _hoisted_35, _toDisplayString(err.studentDocId), 1),
                            _createVNode("td", _hoisted_36, _toDisplayString(err.collectionName), 1),
                            _createVNode("td", _hoisted_37, _toDisplayString(err.errorMessage), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}